import {fsa, fsaPayload, fsaPayloadByKeys} from './helpers'

// -- Actions

// this action expects a react element
export const OPEN_SLIDING_MODAL = 'open sliding modal'
export const openSlidingModal = fsaPayload(OPEN_SLIDING_MODAL)

export const CLOSE_SLIDING_MODAL = 'close sliding modal'
export const closeSlidingModal = fsa(CLOSE_SLIDING_MODAL)

export const OPEN_LOOK_NAME_PANEL = 'open look name panel'
export const openLookNamePanel = fsaPayloadByKeys(OPEN_LOOK_NAME_PANEL, ['products', 'origin'])

export const ADD_LOOK_FOR_SELECTED_LOOK_NAME = 'add look for the selected look name'
export const addLookForSelectedLookName = fsaPayloadByKeys(ADD_LOOK_FOR_SELECTED_LOOK_NAME, [
  'lookName',
])
